import { render } from "./HeaderInside.vue?vue&type=template&id=067aa32c&scoped=true"
import script from "./HeaderInside.vue?vue&type=script&lang=js"
export * from "./HeaderInside.vue?vue&type=script&lang=js"

import "./HeaderInside.vue?vue&type=style&index=0&id=067aa32c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067aa32c"]])

export default __exports__